const UNARY_OPERATORS: string[] = ["is_not_none", "is_none", "is_any"];

export const isUnaryOperator = (operator: string) =>
  UNARY_OPERATORS.includes(operator);
